export const url = "https://admin.tablotala.app/";
export const bannerURL = "https://api.tablotala.app/api/";
// export const baseUrl = `https://cors-anywhere.herokuapp.com/${url}api`
export const baseUrl = `${url}api`;
export const imageUrl = "https://admin.tablotala.app/";

export const IMAGE_URL = (item, keyValue) => {
  if (typeof item == "string") {
    return `https://api.tablotala.app/${item}`;
  }
  if (item?.bucket && item?.bucket != null)
    return `https://${item?.bucket}.${item?.end_point}/${item?.path}/${keyValue ? item[keyValue] : item?.name}`;
  else return "";
};

export const urls = {
  login: "/tv/login",
  logout: "/tv/logout",
  getInfo: "/tv/info",
  getPrices: "/tv/price?type=IR",
  getFrPrices: "/tv/price?type=FR",
  getBanner: "/tv/banners",
  BANNERS: "v1/banners?position=TV1",
  getChartsMenu: "/mobile/chart-menu",
  getChartsByType: "/mobile/chart?type=GOLD&time=",
  getArchiveByType: "/mobile/archive?type=GOLD&date=2020-09-10",
  getNews: "/tv/news",
  getSubscriptions: "/mobile/subscription",
  getSubscriptionsInfo: "/mobile/subscription-info?duration=3&price=2000000",
  buySubscriptions: "/mobile/subscription-payment",
};
